import { Locale } from "./localeConfig";

export type LocalePickerOption = Readonly<{
  locale: Locale;
  labelResourceKey: string;
}>;

export type LocalePickerRegion = Readonly<{
  id: "america" | "europe" | "asiaPacific" | "middleEastAfrica";
  titleResourceKey: string;
  options: readonly LocalePickerOption[];
}>;

export const localePickerRegions: readonly LocalePickerRegion[] = [
  {
    id: "america",
    titleResourceKey: "localePickerAmericaRegionTitle",
    options: [
      {
        locale: Locale.esAR,
        labelResourceKey: "localePickerSpanishArgentina",
      },
      {
        locale: Locale.esBO,
        labelResourceKey: "localePickerSpanishBolivia",
      },
      {
        locale: Locale.ptBR,
        labelResourceKey: "localePickerPortugueseBrazil",
      },
      {
        locale: Locale.enCA,
        labelResourceKey: "localePickerEnglishCanada",
      },
      {
        locale: Locale.frCA,
        labelResourceKey: "localePickerFrenchCanada",
      },
      {
        locale: Locale.esCL,
        labelResourceKey: "localePickerSpanishChile",
      },
      {
        locale: Locale.esCO,
        labelResourceKey: "localePickerSpanishColombia",
      },
      {
        locale: Locale.esCR,
        labelResourceKey: "localePickerSpanishCostaRica",
      },
      {
        locale: Locale.esEC,
        labelResourceKey: "localePickerSpanishEcuador",
      },
      {
        locale: Locale.esSV,
        labelResourceKey: "localePickerSpanishElSalvador",
      },
      {
        locale: Locale.esGT,
        labelResourceKey: "localePickerSpanishGuatemala",
      },
      {
        locale: Locale.esHN,
        labelResourceKey: "localePickerSpanishHonduras",
      },
      {
        locale: Locale.esMX,
        labelResourceKey: "localePickerSpanishMexico",
      },
      {
        locale: Locale.esNI,
        labelResourceKey: "localePickerSpanishNicaragua",
      },
      {
        locale: Locale.esPA,
        labelResourceKey: "localePickerSpanishPanama",
      },
      {
        locale: Locale.esPY,
        labelResourceKey: "localePickerSpanishParaguay",
      },
      {
        locale: Locale.esPE,
        labelResourceKey: "localePickerSpanishPeru",
      },
      {
        locale: Locale.enUS,
        labelResourceKey: "localePickerEnglishUnitedStates",
      },
      {
        locale: Locale.esUY,
        labelResourceKey: "localePickerSpanishUruguay",
      },
    ],
  },
  {
    id: "europe",
    titleResourceKey: "localePickerEuropeRegionTitle",
    options: [
      {
        locale: Locale.sqAL,
        labelResourceKey: "localePickerAlbanianAlbania",
      },
      {
        locale: Locale.nlBE,
        labelResourceKey: "localePickerDutchBelgium",
      },
      {
        locale: Locale.bgBG,
        labelResourceKey: "localePickerBulgarianBulgaria",
      },
      {
        locale: Locale.frBE,
        labelResourceKey: "localePickerFrenchBelgium",
      },
      {
        locale: Locale.bsBA,
        labelResourceKey: "localePickerBosnianBosniaHerzegovina",
      },
      {
        locale: Locale.enCY,
        labelResourceKey: "localePickerEnglishCyprus",
      },
      {
        locale: Locale.hrHR,
        labelResourceKey: "localePickerCroatianCroatia",
      },
      {
        locale: Locale.csCZ,
        labelResourceKey: "localePickerCzechCzechia",
      },
      {
        locale: Locale.daDK,
        labelResourceKey: "localePickerDanishDenmark",
      },
      {
        locale: Locale.etEE,
        labelResourceKey: "localePickerEstonianEstonia",
      },
      {
        locale: Locale.deDE,
        labelResourceKey: "localePickerGermanGermany",
      },
      {
        locale: Locale.esES,
        labelResourceKey: "localePickerSpanishSpain",
      },
      {
        locale: Locale.fiFI,
        labelResourceKey: "localePickerFinnishFinland",
      },
      {
        locale: Locale.frFR,
        labelResourceKey: "localePickerFrenchFrance",
      },
      {
        locale: Locale.elGR,
        labelResourceKey: "localePickerGreekGreece",
      },
      {
        locale: Locale.kaGE,
        labelResourceKey: "localePickerGeorgianGeorgia",
      },
      {
        locale: Locale.huHU,
        labelResourceKey: "localePickerHungarianHungary",
      },
      {
        locale: Locale.isIS,
        labelResourceKey: "localePickerIcelandicIceland",
      },
      {
        locale: Locale.enIE,
        labelResourceKey: "localePickerEnglishIreland",
      },
      {
        locale: Locale.itIT,
        labelResourceKey: "localePickerItalianItaly",
      },
      {
        locale: Locale.lvLV,
        labelResourceKey: "localePickerLatvianLatvia",
      },
      {
        locale: Locale.deLI,
        labelResourceKey: "localePickerGermanLiechtenstein",
      },
      {
        locale: Locale.ltLT,
        labelResourceKey: "localePickerLithuanianLithuania",
      },
      {
        locale: Locale.frLU,
        labelResourceKey: "localePickerFrenchLuxembourg",
      },
      {
        locale: Locale.deLU,
        labelResourceKey: "localePickerGermanLuxembourg",
      },
      {
        locale: Locale.mtMT,
        labelResourceKey: "localePickerMalteseMalta",
      },
      {
        locale: Locale.nlNL,
        labelResourceKey: "localePickerDutchNetherlands",
      },
      {
        locale: Locale.mkMK,
        labelResourceKey: "localePickerMacedonianNorthMacedonia",
      },
      {
        locale: Locale.nbNO,
        labelResourceKey: "localePickerNorwegianNorway",
      },
      {
        locale: Locale.deAT,
        labelResourceKey: "localePickerGermanAustria",
      },
      {
        locale: Locale.plPL,
        labelResourceKey: "localePickerPolishPoland",
      },
      {
        locale: Locale.ptPT,
        labelResourceKey: "localePickerPortuguesePortugal",
      },
      {
        locale: Locale.roMD,
        labelResourceKey: "localePickerRomanianMoldova",
      },
      {
        locale: Locale.roRO,
        labelResourceKey: "localePickerRomanianRomania",
      },
      {
        locale: Locale.ruMD,
        labelResourceKey: "localePickerRussianMoldova",
      },
      {
        locale: Locale.ruRU,
        labelResourceKey: "localePickerRussianRussia",
      },
      {
        locale: Locale.srME,
        labelResourceKey: "localePickerSerbianMontenegro",
      },
      {
        locale: Locale.srRS,
        labelResourceKey: "localePickerSerbianSerbia",
      },
      {
        locale: Locale.skSK,
        labelResourceKey: "localePickerSlovakSlovakia",
      },
      {
        locale: Locale.slSI,
        labelResourceKey: "localePickerSlovenianSlovenia",
      },
      {
        locale: Locale.deCH,
        labelResourceKey: "localePickerGermanSwitzerland",
      },
      {
        locale: Locale.frCH,
        labelResourceKey: "localePickerFrenchSwitzerland",
      },
      {
        locale: Locale.svSE,
        labelResourceKey: "localePickerSwedishSweden",
      },
      {
        locale: Locale.enGB,
        labelResourceKey: "localePickerEnglishUnitedKingdom",
      },
      {
        locale: Locale.ukUA,
        labelResourceKey: "localePickerUkrainianUkraine",
      },
    ],
  },
  {
    id: "asiaPacific",
    titleResourceKey: "localePickerAsiaPacificRegionTitle",
    options: [
      {
        locale: Locale.enAU,
        labelResourceKey: "localePickerEnglishAustralia",
      },
      {
        locale: Locale.enHK,
        labelResourceKey: "localePickerEnglishHongKong",
      },
      {
        locale: Locale.enIN,
        labelResourceKey: "localePickerEnglishIndia",
      },
      {
        locale: Locale.idID,
        labelResourceKey: "localePickerIndonesianIndonesia",
      },
      {
        locale: Locale.enMY,
        labelResourceKey: "localePickerEnglishMalaysia",
      },
      {
        locale: Locale.enNZ,
        labelResourceKey: "localePickerEnglishNewZealand",
      },
      {
        locale: Locale.enPH,
        labelResourceKey: "localePickerEnglishPhilippines",
      },
      {
        locale: Locale.enSG,
        labelResourceKey: "localePickerEnglishSingapore",
      },
      {
        locale: Locale.viVN,
        labelResourceKey: "localePickerVietnameseVietnam",
      },
      {
        locale: Locale.thTH,
        labelResourceKey: "localePickerThaiThailand",
      },
      {
        locale: Locale.koKR,
        labelResourceKey: "localePickerKoreanKorea",
      },
      {
        locale: Locale.zhCN,
        labelResourceKey: "localePickerChineseChina",
      },
      {
        locale: Locale.zhTW,
        labelResourceKey: "localePickerChineseTaiwan",
      },
      {
        locale: Locale.jaJP,
        labelResourceKey: "localePickerJapaneseJapan",
      },
      {
        locale: Locale.zhHK,
        labelResourceKey: "localePickerChineseHongKong",
      },
    ],
  },
  {
    id: "middleEastAfrica",
    titleResourceKey: "localePickerMiddleEastAfricaRegionTitle",
    options: [
      {
        locale: Locale.enZA,
        labelResourceKey: "localePickerEnglishSouthAfrica",
      },
      {
        locale: Locale.trTR,
        labelResourceKey: "localePickerTurkishTurkey",
      },
    ],
  },
];

export const localePickerOptions: readonly LocalePickerOption[] = localePickerRegions.flatMap(
  region => region.options
);
